import React from "react";
import PropTypes from "prop-types";
import "./styles.css";
import { Link } from "react-router-dom";
import AccessTimeOutlined from "@material-ui/icons/AccessTimeOutlined";
import AccountBalanceWalletOutlined from "@material-ui/icons/AccountBalanceWalletOutlined";
import WarningOutlined from "@material-ui/icons/WarningOutlined";
import classNames from "classnames";
import Button from "@material-ui/core/Button";

const TestItemOngoingHorizontal = ({ test, test: { project } }) => {
  let diffDays = null;
  let summaryDays = null;
  if (project.start_date && project.end_date) {
    const startDate = new Date(project.start_date);
    const endDate = new Date(project.end_date);
    const nowDate = new Date();
    diffDays = nowDate.getDate() - endDate.getDate();
    summaryDays = endDate.getDate() - startDate.getDate();
  }
  return (
    <div className={"test-item-ongoing-horizontal-root"}>
      {/*<div>*/}
      {/*  <span className={"test-item-ongoing-horizontal-days"}>*/}
      {/*    {diffDays}/{summaryDays}*/}
      {/*  </span>{" "}*/}
      {/*  días*/}
      {/*</div>*/}
      <img
        className={"test-item-ongoing-horizontal-img"}
        src="/assets/img/dummy/placeimg_320_320_arch.jpg"
      />

      <div className={"test-item-ongoing-horizontal-project-type"}>
        <Link to={`/test/${test.id}/ongoing`}>
          {project && project.project_type && project.project_type.name}
        </Link>
      </div>

      <div className={"test-item-ongoing-horizontal-description"}>
        {"-"}
        {/*Description manufactures 1 tips a device come that from helps the safety*/}
        {/*trains with experts braking, at Voith to make Turbo, train York, travel*/}
        {/*Pa.,even which better.*/}
      </div>
      <div className={"test-item-ongoing-horizontal-info"}>
        <div>
          <AccessTimeOutlined />{" "}
          {Array.isArray(project.medical_visits) &&
            project.medical_visits[0] && (
              <span>Día inicio {project.medical_visits[0].date}</span>
            )}
        </div>
        <div>
          <AccessTimeOutlined />{" "}
          {Array.isArray(project.medical_visits) &&
            project.medical_visits[1] && (
              <span>Día fin {project.medical_visits[1].date}</span>
            )}
        </div>
        {/*<div>*/}
        {/*  <AccountBalanceWalletOutlined /> Retribución : 45CC*/}
        {/*</div>*/}
      </div>
      <div>
        <Link to={`/test/${test.id}/report/project/${test.project.id}`}>
          <WarningOutlined
            className={"test-item-ongoing-horizontal-warning-icon"}
          />{" "}
          <span className={"test-item-ongoing-horizontal-warning-text"}>
            Informar de un problema
          </span>
        </Link>
      </div>
    </div>
  );
};

TestItemOngoingHorizontal.propTypes = {
  test: PropTypes.object.isRequired
};

export default TestItemOngoingHorizontal;



// WEBPACK FOOTER //
// ./src/modules/test/components/TestItemOngoingHorizontal/test-item-ongoing-horizontal.js